import * as colors from '@giphy/colors'

import { usePathname } from 'next/navigation'
import { useContext } from 'react'
import styled, { css } from 'styled-components'
import { belowHeaderZIndex } from 'ui/src/constants'
import { desktop } from 'ui/src/css'
import { useOpenInAppCopy } from '../context/site-chrome-copy'
import RouteContext from '../context/route-context'

const PEEKER_URL = 'https://media.giphy.com/media/XJtM2nNFCzT3etvzOB/200.gif'

const BASE_URL = `https://giphy.page.link?apn=com.giphy.messenger&isi=974748812&ibi=com.giphy.giphyformessenger&ius=giphy&efr=1`

export const OpenInAppContainer = styled.div`
    position: fixed;
    left: 50%;
    bottom: 25px;
    transform: translateX(-50%);
    width: max-content;
    display: flex;
    justify-content: center;
    z-index: ${belowHeaderZIndex};
    ${desktop(css`
        display: none;
    `)}
`

const Button = styled.a`
    background: linear-gradient(90deg, ${colors.giphyIndigo}, ${colors.giphyPurple});
    border-radius: 25px;
    box-shadow: 0 2px 14px rgba(0, 0, 0, 0.33);
    color: ${colors.giphyWhite};
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
    position: relative;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    width: 150px;
    height: 45px;

    &:before {
        background: no-repeat url(${PEEKER_URL}) center center;
        background-size: contain;
        content: '';
        height: 45px;
        left: -8px;
        position: absolute;
        top: -30px;
        width: 90px;
    }
`
// default to Home and the home deep link
// taken from https://giphypedia.atlassian.net/wiki/spaces/PE/pages/908591144/Deep+Linking+Product+Brief
const OpenInAppCTA = () => {
    const pathname = usePathname()
    const { route } = useContext(RouteContext)
    const copy = useOpenInAppCopy()
    let href = 'https://giphy.page.link/home'
    switch (route) {
        case '/settings':
            return null
        case '/':
            href = `https://giphy.page.link/home`
            break
        case '/search/[term]':
        case '/explore/[term]':
            href = `${BASE_URL}&link=${encodeURIComponent(`https://giphy.com/search/${pathname}`)}`
            break
        case `/[username]`:
        case `/[username]/clips`:
        case `/[username]/[...channel]`:
        case `/[username]/tagged/[term]`:
            href = `${BASE_URL}&link=${encodeURIComponent(`https://giphy.com/channel/${pathname}`)}`
            break
        default:
        // href = `https://giphy.page.link/${asPath}`
    }
    return (
        <OpenInAppContainer>
            <Button href={href} target="_blank" className="ci-hidden">
                {copy.tryOurApp}
            </Button>
        </OpenInAppContainer>
    )
}

export default OpenInAppCTA
